export default {
    //getAPIRootURL() 
    //{
    //    return process.env.REACT_APP_SMARTBADGEAPI_URL
    //},
    getProxyRootURL() 
    {
        let baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
        return `${window.location.protocol}//${window.location.host}${baseUrl}Proxy/`
    },
    getDate(datestring) {
        return new Date(datestring)
    }, 
    getCurrentTime() {
        return new Date();
    },
    getOneHourAgo() {
        const currentDate = new Date();
        return new Date(currentDate.getTime() - 60 * 60 * 1000);
    },
    getTwentyFourHoursAgo() {
        const currentDate = new Date();
        return new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
    },
    getOneWeekAgo() {
        const currentDate = new Date();
        return new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
    },
    getRuntime(date1, date2) {
        const difference = Math.abs(date1 - date2);
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        const minutesString = (minutes < 10) ? `0${minutes}` : `${minutes}`
        const seconddsString = (seconds < 10) ? `0${seconds}` : `${seconds}`
        
        let runtime = ''

        if(difference === 0) {
            runtime = '----'
        } else {
            if(hours > 0) {
                runtime = `${hours}:`
            }
            runtime = runtime + `${minutesString}:${seconddsString}`
        }
    
        return runtime;
    },
    checkIfJobIsRunning(data) {
        if(data.jobStatus === 'Completed' || data.expectToProcess === data.totalProcessed) {
            return data.notes
        }
        if(data.notes === "Job did not complete") {
            if(data.createdDate === data.processedDate) {
                if((new Date() - new Date(data.createdDate)) / (1000 * 60) <= 15) { // check if the job was created in the last 15 minutes
                    return 'Job is currently running'
                }
            }
        }
        return data.notes
    }
}
